import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 40,
		height: 32,
		rx: 4,
		fill: "#76ec71"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M32 19.4286V12.5714H25.1429V15.1429H20.8571V8.28571C20.8571 7.83106 20.6765 7.39502 20.355 7.07353C20.0335 6.75204 19.5975 6.57143 19.1429 6.57143H14.8571V4H8V10.8571H14.8571V8.28571H19.1429V23.7143C19.1429 24.1689 19.3235 24.605 19.645 24.9265C19.9665 25.248 20.4025 25.4286 20.8571 25.4286H25.1429V28H32V21.1429H25.1429V23.7143H20.8571V16.8571H25.1429V19.4286H32ZM13.1429 9.14286H9.71429V5.71429H13.1429V9.14286ZM26.8571 22.8571H30.2857V26.2857H26.8571V22.8571ZM26.8571 14.2857H30.2857V17.7143H26.8571V14.2857Z",
		fill: "black"
	})]
});
export default SvgListIcon;
